import { MKPLAYER_LICENSE_KEY as MKLicenseKey } from "../utils/apiConstants";

export function usePlayerConfig(
  VideoUrl,
  Authorization,
  timelineMarkers,
  MKPLAYER_LICENSE_KEY = MKLicenseKey,
  muted = true,
  autoplay = true,
  ui = true
) {
  //Checking if device is safari or not
  let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  let playerConfig = {
    key: MKPLAYER_LICENSE_KEY,
    playback: {
      muted: muted,
      autoplay: autoplay,
    },
    ui: ui,
  };

  if (timelineMarkers)
    playerConfig = {
      ...playerConfig,
      timelineMarkers: timelineMarkers,
    };

  if (isSafari) {
    console.log("inside Safari browser");
    playerConfig = {
      ...playerConfig,
      playback: {
        ...playerConfig.playback,
        preferredTech: [
          {
            player: "html5",
            streaming: "hls",
          },
        ],
      },
    };
  }

  const sourceConfig = {
    hls: VideoUrl,
    drm: {
      clearkey: {
        LA_URL: "HLS_AES",
        headers: {
          Authorization: Authorization,
        },
      },
    },
  };
  return { playerConfig, sourceConfig };
}
